
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import GiftCardProgressBar from "../common/GiftCardProgressBar";
import { lookupGiftCard } from "../../../services/giftCardService";
import { resetCheckout } from "../../../redux/slices/giftCardCheckoutSlice";

const GiftCardThankYouPage = () => {
  const { sessionId } = useParams();
   const dispatch = useDispatch();
  const { purchaseResult, loading } = useSelector(
    (state) => state.giftCardReducer
  );

  useEffect(() => {
    dispatch(resetCheckout());
    if (sessionId) {
      dispatch(lookupGiftCard(sessionId));
    }
  }, [dispatch, sessionId]);

  return (
    <div className="max-w-4xl mx-auto min-h-screen bg-white p-4">
      <GiftCardProgressBar
        steps={["Select", "Confirm & Pay", "Thank You"]}
        currentStep={2}
      />
      <div className="pt-5">
        {loading && (
          <p className="text-gray-500 text-center">
            Loading ....
          </p>
        )}

        {!loading && purchaseResult && (
          <>
           <h2 className="text-sm lg:text-md font-semibold text-black mb-3 lg:text-xl">
              Thank You! Your {purchaseResult.productName} Card is being processed.
            </h2>
{/* 
            <div className="text-[#8C8C8C] text-[12px] lg:text-sm font-[400] space-y-2">
              <p>
                You can view it in the My Gift Cards section of the app.
              </p>

              <div>
                <p>We’ve also sent a confirmation email to:</p>
                <p className="font-semibold">
                  {purchaseResult.emailRecipient}
                </p>
              </div>
            </div> */}
              <div className="text-[#8C8C8C] text-[12px] lg:text-sm font-[400] space-y-2">
              <p>
                We're preparing your eGift Card and will send you an email once it's ready.
              </p>
              <div>
                <p>A confirmation email will be sent to:</p>
                <p className="font-semibold">{purchaseResult.emailRecipient}</p>
              </div>
              <p>
                You can also view your card anytime in the <strong>My Gift Cards</strong> section of the app.
              </p>
            </div>
          </>
        )}

        {!loading && !purchaseResult && (
          <p className="text-red-500 text-center">
            Could not load purchase details. Please contact support.
          </p>
        )}
      </div>
    </div>
  );
};

export default GiftCardThankYouPage;
